/*
 * Public API Surface of ngx-ef-flags
 */

export * from './lib/ngx-ef-flags.component';
export * from './lib/ngx-ef-flags.module';
